import {fabric} from 'fabric';

fabric.util.object.extend(fabric.Textbox, {
  async fromObject(object, callback) {
    const styles = fabric.util.stylesFromArray(object.styles, object.text);
    const objCopy = {...object, styles};
    let obj;

    try {
      const promises = Array.from(document.fonts.values())
        .filter(({family}) => family === object.fontFamily)
        .map((font) => font.load());
      await Promise.allSettled(promises);
    } catch (error) {
      evite.log(`${object.fontFamily} Error loading font: ${error}. Ignoring and moving on...`);
    } finally {
      obj = fabric.Object._fromObject('Textbox', objCopy, callback, 'text');
    }
    return obj;
  },
});
